import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { SmallPrimaryButton } from '../../components/Button'
import { roundedCardHeading } from '../../components/RoundedCard'
import { MOBILE } from '../../guided-toolbox/utils/breakpoints'

// Inset section content at the selected breakpoint without narrowing its background.
export const gutter = (breakpoint = MOBILE) => css`
  ${breakpoint} {
    padding-left: 20px;
    padding-right: 20px;
  }
`

export const mobileGutter = gutter()

export const DashboardPageContainer = styled.div`
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 55px 20px 12px;
  display: flex;
  flex-direction: column;
`

export const DashboardAddButton = styled(SmallPrimaryButton)`
  min-width: 151px;
  line-height: 22px;

  ${MOBILE} {
    width: 100%;
  }
`

export const SectionHeading = styled.h2`
  ${roundedCardHeading};
`
